export default __webpack_public_path__ + "static/media/Madurai-Ramanad.4127dfe7.png";